import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import SideNavbar from "./SideNavbar";
// import SideNavbar from "./SideNavbar";
// import logout from "./map/icons/logout.svg";
// import profile from "./map/icons/profile.svg";
// import logo from "../assets/CropSnapPro_Horizontal.png";
// import { Link } from "react-router-dom";
// import { MdLogout } from "react-icons/md";
// import { IoHomeOutline } from "react-icons/io5";
// import { GiHamburgerMenu } from "react-icons/gi";
// import { getDateRange } from "../helper";
import Logo from "../assets/newLOGO.png";
import { FaUser } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";
import { AppContext } from "../Context/Context";

function Navbar() {

    const { user, setUser } = useContext(AppContext);

    const navigate = useNavigate();
    const handleLogout = () => {
        setUser(() => null);
        localStorage.removeItem("userInfo");
        navigate("/login");

        // setImgCarousel(false);
        // setData([]);
        // setFilters_State((prev) => ({
        //   ...prev,
        //   State: "Assam",
        //   District: "",
        //   Mandal_Block: "",
        //   from_date: result.lastMonth,
        //   to_date: result.today,
        // }));
        // setMaps(false);
        // setMap_polygons((prev) => ({
        //   ...prev,
        //   lat: null,
        //   lng: null,
        //   polygons: "",
        // }));
        // setOptions((prev) => ({
        //   ...prev,
        //   District: [],
        //   Mandal_Block: [],
        // }));
        // setDownloadState((prev) => ({
        //   ...prev,
        //   csv: false,
        //   image: false,
        //   kml: false,
        // }));
        // setShowpopups_ans(false);
        // setShowpopups(false);
        // setImages_url({});
        // setCount(0);
        // setSort({
        //   Display_Id: { status: true, sort: 1, active: "Date" },
        //   State: { status: true, sort: 1, active: "Date" },
        //   District: { status: true, sort: 1, active: "Date" },
        //   Mandal_Block: { status: true, sort: 1, active: "Date" },
        //   Crop_Name: { status: true, sort: 1, active: "Date" },
        //   Stage_Name: { status: true, sort: 1, active: "Date" },
        //   Condition_Name: { status: true, sort: 1, active: "Date" },
        //   Date: { status: true, sort: 1, active: "Date" },
        // });
        // setSelectedDI(null);
    };

    return (
        <div className={`px-5 py-1 grid grid-cols-3 gap-4  bg-gray-200 shadow-md`}>
            <div className="flex justify-start items-center col-span-1">
                {/* <GiHamburgerMenu color="#1e293b"  size={24} /> */}
                {/* <SideNavbar /> */}
                <SideNavbar />

                {/* <img  className="w-36" src={logo} alt="" /> */}
            </div>

            <div className="border flex  justify-center items-center col-span-1 text-xl font-medium">
                <div className="flex  justify-center items-center">
                    <img width="35%" src={Logo} alt="InfestsnapLogo" />
                    {/* <span className="font-light text-2xl">
            InfestSnap Dashboard
          </span> */}
                </div>
            </div>

            <div className="flex justify-end items-center col-span-1">
                <div className=" flex justify-around gap-3 items-center border-r border-black pl-5">
                    {/* <FaUser color="#1e293b" size={24} /> */}
                    {/* <img src={profile} alt="profile" /> */}
                    <FaUser color="#1e293b" size={20} />
                    <p className="mr-5 text-[#1e293b] text-xs">{user?.userName}</p>
                </div>
                <div className="ml-3 cursor-pointer" title="logout" onClick={handleLogout}>
                    {/* <img src={logout} alt="logout" /> */}
                    <IoLogOut color="#1e293b" size={25} />
                    {/* <MdLogout color="#1e293b" size={30} /> */}
                </div>
            </div>
        </div>
    );
}

export default Navbar;
